<template>
    <div><PublicViewEvent :me="$store.state.me" :slug="$route.params.slug" :eventTicketsOn="eventsTicketsOn" /></div>
</template>

<script>
import PublicViewEvent from '@/components/Templates/User/Event/View/PublicEventView.vue';

export default {
    name: 'CoViewPublicEvent',
    components: {
        PublicViewEvent,
    },
    data() {
        return {
            eventsTicketsOn: this.$unleash.isEnabled('frontend.eventGuestTicketsOn'),
        };
    },
    created() {
        this.$unleash.on('ready', () => {
            if (this.$unleash.isEnabled('frontend.eventGuestTicketsOn')) {
                this.eventsTicketsOn = true;
            } else {
                this.eventsTicketsOn = false;
            }
        });
    },
};
</script>
